import { render, staticRenderFns } from "./OrdenesIdeales.vue?vue&type=template&id=a00770dc"
import script from "./OrdenesIdeales.vue?vue&type=script&lang=js"
export * from "./OrdenesIdeales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports